import { render, staticRenderFns } from "./cardV3.vue?vue&type=template&id=3f028066&scoped=true"
import script from "./cardV3.vue?vue&type=script&lang=js"
export * from "./cardV3.vue?vue&type=script&lang=js"
import style0 from "./cardV3.vue?vue&type=style&index=0&id=3f028066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f028066",
  null
  
)

export default component.exports